import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder} from '@angular/forms';

@Component({
  selector: 'app-estado-cambio',
  templateUrl: './estado-cambio.component.html',
  styleUrls: ['./estado-cambio.component.scss']
})
export class EstadoCambioComponent implements OnInit {

  constructor(public dialoRef: MatDialogRef<EstadoCambioComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any ) { }

  ngOnInit(): void {
  }

}
